import React from 'react';
import moment from 'moment';

import api from '../../../api';
import Button from '../../../elements/Button/Button';
import { webhooksActions } from '../../../redux/reducers/webhooks';
import { webhookState } from '../../../redux/reducers/webhook';
import { useAppSelector, useAppDispatch } from '../../../hooks/useRedux';
import settings from '../../../pages/apps/Settings.module.scss';
import strings from '../../../lang/lang';
import WebhookCertificateItem from './WebhookCertificateItem';
import { ReactComponent as UploadIcon } from '../../../styles/icon/upload.svg';

interface ICertificate {
  appId: string;
  webhookId: string;
}

function WebhookCertificate(props: ICertificate) {
  const dispatch = useAppDispatch();
  const webhookData = useAppSelector(webhookState);
  const { certificates = [] } = webhookData;
  const { appId, webhookId } = props;

  function downloadFile(certificateId, fileName) {
    return api.portal
      .downloadWebhookCertificate(appId, webhookId, certificateId)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => URL.createObjectURL(blob))
      .then((url) => {
        let fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = fileName;
        fileLink.click();
        URL.revokeObjectURL(url);
      });
  }

  return (
    <>
      <h3>{strings.appWebhookDetails.text.certificatesTitle}</h3>
      <p style={{ marginBottom: 25 }}>{strings.appWebhookDetails.text.certificatesDescription}</p>

      {!certificates || !certificates.length ? (
        <div className={settings.settings__no_webhook_certificate}>
          {strings.appWebhookDetails.text.noCertificates}
        </div>
      ) : (
        <>
          {certificates &&
            certificates.map((c) => {
              const certId = c.id;
              const validDate = moment.utc(c.validFrom).local().format('YYYY-MM-DD HH');
              const expDate = moment.utc(c.validUntil).local().format('YYYY-MM-DD HH');
              const fileName = c.fileName;
              return (
                <WebhookCertificateItem
                  key={certId}
                  fileName={fileName}
                  expDate={expDate}
                  validDate={validDate}
                  onClick={() => downloadFile(certId, fileName)}
                  onRevoke={() => dispatch(webhooksActions.setActiveModalDetails({ name: 'delete a certificate', id: c.id }))}
                />
              );
            })}
        </>
      )}
      <Button
        type="button"
        name={strings.appWebhookDetails.buttons.upload}
        variant="primary"
        secondaryClassName="lg"
        onClick={() => dispatch(webhooksActions.setActiveModalDetails({ name: 'upload a certificate' }))}
        style={{ marginTop: 25 }}
      >
        <UploadIcon />
      </Button>
    </>
  );
}

export default WebhookCertificate;
